import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import StatusTableContainer from '../containers/status-table.container';
import StatusDetailsContainer from '../containers/status-details.container';
import StatusCreateContainer from '../containers/status-create.container';
import StatusUpdateContainer from '../containers/status-update.container';
import {
  DEFAULT_PAGINATION_LIMIT,
  DEFAULT_PAGINATION_PAGE,
} from '../../../../../const/default-paginated-table-data.const';
import TenantGuard from '@components/common/TenantGuard';

// Helper function to add default query parameters to the status list page
const StatusListWithParams = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  // Set default params if they don't exist
  if (!params.has('page')) {
    params.set('page', DEFAULT_PAGINATION_PAGE.toString());
  }
  if (!params.has('limit')) {
    params.set('limit', DEFAULT_PAGINATION_LIMIT.toString());
  }

  // If query params need to be added
  if (location.search !== `?${params.toString()}`) {
    return <Navigate to={`?${params.toString()}`} replace />;
  }

  return <StatusTableContainer />;
};

export const statusRoutes = [
  {
    path: 'status',
    element: (
      <TenantGuard showHeader={true} headerTitle="Status List" showBreadcrumbs={true}>
        <StatusListWithParams />
      </TenantGuard>
    ),
  },
  {
    path: 'status/create',
    element: (
      <TenantGuard showHeader={true} headerTitle="Create Status" showBreadcrumbs={true}>
        <StatusCreateContainer />
      </TenantGuard>
    ),
  },
  {
    path: 'status/:id',
    element: (
      <TenantGuard showHeader={true} headerTitle="Status Details" showBreadcrumbs={true}>
        <StatusDetailsContainer />
      </TenantGuard>
    ),
  },
  {
    path: 'status/:id/update',
    element: (
      <TenantGuard showHeader={true} headerTitle="Update Status" showBreadcrumbs={true}>
        <StatusUpdateContainer />
      </TenantGuard>
    ),
  },
];

export default statusRoutes;

